function toSnakeCase(text) {
  return text
    .replace(/(.)([A-Z][a-z]+)/, "$1_$2")
    .replace(/([a-z0-9])([A-Z])/, "$1_$2")
    .toLowerCase();
}

let marketoInitialised = false;
let retryCount = 15;

const initialise_forms = () => {
  if (!marketoInitialised && retryCount--) {
    // Make sure Marketo script is available
    if (typeof MktoForms2 !== "undefined") {
      MktoForms2.whenReady(function (form) {
        form.onSuccess((values) => {
          window.dataLayer = window.dataLayer || [];
          let localDataLayer = {
            event: "marketo-embedded-form-success",
          };

          for (const [key, value] of Object.entries(values)) {
            const snakeCaseKey = toSnakeCase(key);
            localDataLayer[snakeCaseKey] = value;
          }
          window.dataLayer.push(localDataLayer);
        });
      });

      console.log("Forms initialised");
      marketoInitialised = true;
    } else {
      console.log("Forms not ready, try again...");
      setTimeout(initialise_forms, 100);
    }
  }
};

initialise_forms();
